export function pluralize(count: number, singular: string, plural: string): string {
  const rules = new Intl.PluralRules('es');
  const category = rules.select(count);

  return category === 'one' ? singular : plural;
}
